/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-17T03:15:09.135Z
 */

// prettier-ignore
export const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmbedContainerQuery', // 22
	'EmojiTitleQuery', // 23
	'EndOfPageRecommendationQuery', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 25
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 26
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 27
	'FollowingFeedWithSortByStorageSnippetsQuery', // 28
	'FooterCreateButtonsQuery', // 29
	'ForgeExtensionList', // 30
	'GlobalNavigationComponentQuery', // 31
	'GrantAccessDialogLoaderQuery', // 32
	'HomeRecentWorkQuery', // 33
	'InlineCommentsFocusedInlineCommentQuery', // 34
	'LegacyMacroRendererQueryBodyQuery', // 35
	'LivePagesByLineLastUpdatedQuery', // 36
	'LocalStorageQuery', // 37
	'NativeCollabQuery', // 38
	'NotFoundContainerQuery', // 39
	'NotificationsButtonQuery', // 40
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 41
	'PageRestrictionsContextQuery', // 42
	'PageTreeQuery', // 43
	'PageTreeQueryWithSpaceKeyQuery', // 44
	'PermissionCheckAddCommentQuery', // 45
	'PersistentInviteEligibleQuery', // 46
	'PersonalizedTemplatesV2AllTemplatesQuery', // 47
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 48
	'Preferences', // 49
	'PremiumTrialEotQuery', // 50
	'ReactionsContentQuery', // 51
	'RendererContentStateQuery', // 52
	'RestrictedPageWithCanViewQuery', // 53
	'ScreenQuery', // 54
	'SiteInformationQuery', // 55
	'SmartCreateFeedbackBannerQuery', // 56
	'SmartCreatePageEditorDataWrapperComponentQuery', // 57
	'SpaceNavigationQuery', // 58
	'SpaceOverviewIdQuery', // 59
	'SpaceOverviewQuery', // 60
	'SpaceQuery', // 61
	'SpaceRestrictionCheckQuery', // 62
	'ThemeQuery', // 63
	'TopNavigationQuery', // 64
	'UserSettingsQuery', // 65
	'ViewSpaceExternalCollaboratorsDialogQuery', // 66
	'WebItemLocationQuery_page.metadata.banner', // 67
	'WebItemLocationQuery_system.content.byline', // 68
	'WebItemLocationQuery_system.header_left', // 69
	'WebItemLocationQuery_system.header_left_system.user', // 70
	'WebPanelLocationQuery_atl.footer', // 71
	'WebPanelLocationQuery_atl.general', // 72
	'WebPanelLocationQuery_atl.general_atl.footer', // 73
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 74
	'WebStorageCategories', // 75
	'WelcomeMessagesQuery', // 76
	'WhiteboardUnifiedQuery', // 77
	'contentAppearanceQuery', // 78
	'contentSmartLinksORS', // 79
	'fetchMentionsProviderDataQuery', // 80
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 81
	'graphqlHelpersFetchMediaTokenQuery', // 82
	'multiMacroQueryWithAppKeyQuery', // 83
	'onboardingStateGetOnboardingStateQuery', // 84
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 85
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9', // 86
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 87
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 88
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 89
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 90
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 91
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages', // 92
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 93
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 94
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 95
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_66', // 96
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 97
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 100
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 101
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 102
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_153', // 103
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_154', // 104
	'pageButtons', // 105
	'preloadAutohighlightsQuery', // 106
	'preloadContentSmartLinksQuery', // 107
	'preloadCreateSpaceQuery', // 108
	'preloadEditButtonWithSpaceKeyQuery', // 109
	'preloadEditorNodeDataProvidersDataQuery', // 110
	'preloadLegacyBridgeQuery', // 111
	'preloadOperationsQuery', // 112
	'preloadPageStatusQueryDataQuery', // 113
	'preloadPersonalSpaceDetailsQuery', // 114
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 115
	'preloadSpaceBlogCountQuery', // 116
	'preloadTemplatesCollectionEligibleQuery', // 117
	'requireSuperBatchFrontendResourceRenderQuery', // 118
	'rightPanel', // 119
	'searchCombinedConfig', // 120
	'searchResults', // 121
	'sidenavSmartLinksORS', // 122
	'useAnalyticsByLineQuery', // 123
	'useAudioContentQuery', // 124
	'useConfluenceStandardToPremiumExperimentQuery', // 125
	'useContentClassificationContentDataClassificationQuery', // 126
	'useEditorContentModeValueQuery', // 127
	'useEmojiEverSetPropertyQuery', // 128
	'useFabricEligibilityMigrationQuery', // 129
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 130
	'useFeedTypeSelectorRefreshQuery', // 131
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 132
	'useGetCurrentStorageUsageQuery', // 133
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 134
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 135
	'useHomeWidgetStateQuery', // 136
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 137
	'useIsLoomEntryPointsEnabledQuery', // 138
	'useIsUserViewingSpaceAsAnonQuery', // 139
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 140
	'useLoomTenantProvisionStatusQuery', // 141
	'usePopularFeedWithTimeGranularityStorageQuery', // 142
	'usePreloadCommentButtonQuery', // 143
	'useReadTimeQuery', // 144
	'useRegisterAdminAnnouncementBannerQuery', // 145
	'useShareAndRestrictButtonDataQuery', // 146
	'useShortcutsSpaceNavigationQuery', // 147
	'useSpaceBaseQueryBaseQuery', // 148
	'useSpaceDetailQuery', // 149
	'useSpaceEnabledContentTypesQuery', // 150
	'useSpaceViewsDataSpaceRootQuery', // 151
	'useSpaceViewsOptionsPersistenceQuery', // 152
	'useSpacesDataAnonymousSpacesQuery', // 153
	'useSpacesDataMyVisitedSpacesQuery', // 154
	'useSpacesDataStarredSpacesQuery', // 155
	'useTitleContentPropertiesForEditorQuery', // 156
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 157
	'useTitleContentPropertiesForPublishedPageQuery', // 158
	'useUserByLicensedProductsQuery', // 159
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	'prod-apne': 'bdffbbeef4fdf6ffbf65bf7dbffffffaefbdfff9', /* 132 fast, 13 slow, 9 excl */
	'prod-apne2': 'bdffbbeef5bdf6ffbf65bf7dbffe9bfaefbdff79', /* 127 fast, 17 slow, 50 excl */
	'prod-apse': 'bdffbfeef7bffeffbf6dbffdbffffffaefbdfffb', /* 139 fast, 12 slow, 8 excl */
	'prod-apse2': 'bdffbbeef5bffeffbf7dbffdbffffffacfbdffff', /* 138 fast, 12 slow, 22 excl */
	'prod-apsouth': '9dffbbeef4bdf6ffbf75bffdbfffbffaeebdfffd', /* 131 fast, 13 slow, 46 excl */
	'prod-cacentral': 'bdffbbeef6fffeffbf7dbffdbfffbffaefbffffd', /* 139 fast, 7 slow, 7 excl */
	'prod-east': 'bdffffeef7fffeffbf7dbffdbffffffaefbfffff', /* 144 fast, 9 slow, 118 excl */
	'prod-eucentral': 'bfffbfeef7bffeffbf6dbffdfffffff2efbdffff', /* 141 fast, 12 slow, 74 excl */
	'prod-eucentral2': 'a5dfbb6ef0bdfefd3f65b77dbffe2ff0efbcff7d', /* 117 fast, 24 slow, 12 excl */
	'prod-euwest': 'bfffbfeef7fffeffbf7dbffdfffffffaefbfffff', /* 145 fast, 8 slow, 63 excl */
	'prod-euwest2': 'bdffbbeef7fffeffbf75bffdbffffffaefbffffd', /* 140 fast, 7 slow, 12 excl */
	'prod-west2': '9dffbfeefdfffeffbf7dbffdbffffffaefbfffff', /* 142 fast, 9 slow, 98 excl */
	'stg-east': '76b7bbffd0efbac5ff57bffbbedcb7feefbfefdf', /* 123 fast, 18 slow, 53 excl */
};
